import { defineAsyncComponent } from 'vue'
export default {
  app: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/app.vue").then(m => m.default || m)),
  blinkproject: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/blinkproject.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/home.vue").then(m => m.default || m)),
  landing: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/landing.vue").then(m => m.default || m)),
  project: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/project.vue").then(m => m.default || m))
}